// document.addEventListener("DOMContentLoaded", function () {
//   const toggleLink = document.querySelector(".toggle-link");
//   const descContainer = document.querySelector(".product__description");

//   toggleLink.addEventListener("click", function (e) {
//     e.preventDefault();
//     descContainer.classList.toggle("expanded");
//     toggleLink.textContent = descContainer.classList.contains("expanded") ? "Read less" : "Read more";
//   });
// });
// one listener for the whole document
document.addEventListener('click', function (e) {
  const toggle = e.target.closest('.toggle-link');
  if (!toggle) return;                  // click was somewhere else

  e.preventDefault();

  // scope the description to the same modal (or other wrapper) if you like
  const desc = toggle
    .closest('.modal, body')            // first ancestor that is the modal, or <body> as a fallback
    .querySelector('.product__description');

  if (!desc) return;

  desc.classList.toggle('expanded');
  toggle.textContent = desc.classList.contains('expanded') ? 'Read less' : 'Read more';
});
